import type { UserModuleGrant } from "../types";

const PERSIST_KEY = "itaas:user-module-grants:v1";

function isUserModuleGrant(value: unknown): value is UserModuleGrant {
  if (!value || typeof value !== "object") return false;
  const grant = value as UserModuleGrant;
  return (
    typeof grant.userId === "string" &&
    typeof grant.tenantId === "string" &&
    typeof grant.moduleId === "string" &&
    typeof grant.granted === "boolean" &&
    typeof grant.updatedAt === "string"
  );
}

function loadFromStorage(): UserModuleGrant[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(PERSIST_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(isUserModuleGrant);
  } catch {
    return [];
  }
}

function saveToStorage(next: UserModuleGrant[]): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(PERSIST_KEY, JSON.stringify(next));
}

let grants: UserModuleGrant[] = loadFromStorage();

export function getUserModuleGrantsStore(): UserModuleGrant[] {
  return grants;
}

export function setUserModuleGrantsStore(next: UserModuleGrant[]): void {
  grants = next;
  saveToStorage(grants);
}

export function mutateUserModuleGrants(
  mutator: (current: UserModuleGrant[]) => UserModuleGrant[]
): void {
  grants = mutator(grants);
  saveToStorage(grants);
}
